import { Close } from "components/atoms/Close";

export const DrawerClose = ({ onClick }: { onClick(): void }): JSX.Element => {
  return (
    <div onClick={onClick}>
      <Close />
    </div>
  );
};
